module.exports = __webpack_public_path__ + "img/gift-snipers.2dc9a54.png";